import { Injectable } from '@angular/core';
import { Callbacks, FollowUpSopChangeType, FollowUpSopType, MorningNightProductType, RegimenSop } from '@cureskin/regimen-sop';

@Injectable( { providedIn: 'root' } )
export class RegimenSopServices {
  private readonly regimenSop: RegimenSop = new RegimenSop();

  constructor() {}

  async changeRegimen(morning: Array<MorningNightProductType>, night: Array<MorningNightProductType>, changes: Array<FollowUpSopChangeType>,
    callBacks: Callbacks): Promise<{ morning: Array<MorningNightProductType>; night: Array<MorningNightProductType> }>  {
    return await this.regimenSop.changeRegimen({
      morning,
      night,
    }, changes, callBacks);
  }

  getFollowUpSopOfSelectedOption(followUpSops: Array<FollowUpSopType>, selectedFollowUpSopOption: string): FollowUpSopType  {
    return this.regimenSop.getFollowUpSopOfSelectedOption(followUpSops, selectedFollowUpSopOption);
  }

  getFollowUpSopsForCurrentFollowUp(followUpSops: Array<FollowUpSopType>, followUpCount: number, followUpSopTransition: Array<string>)
    : Array<FollowUpSopType>  {
    return this.regimenSop.getFollowUpSopsForCurrentFollowUp(followUpSops, followUpCount, followUpSopTransition);
  }
}
